export const isSkipRentHelperTrapParamExists = () => {
  return window.location.search.includes('skipRentHelperTrap');
};
